const notifications = {
  namespaced: true,
  state: {
    success: null,
    error: null,
    errorBag: null,
    info: null
  },
  getters: {
    success: state => state.success,
    error: state => state.error,
    errorBag: state => state.errorBag,
    info: state => state.info,
  },
  mutations: {
    setSuccess(state, success) {
      state.success = success;
    },
    setError(state, error) {
      state.error = error;
    },
    setErrorBag(state, errorBag) {
      state.errorBag = errorBag;
    },
    setInfo(state, info) {
      state.info = info;
    },
    clear(state) {
      state.success = null;
      state.error = null;
      state.errorBag = null;
      state.info = null;
    }
  },
  actions: {
    setSuccess({commit}, success) {
      commit('setSuccess', success);
    },
    setError({commit}, error) {
      commit('setError', error);
    },
    setErrorBag({commit}, errorBag) {
      commit('setErrorBag', errorBag);
    },
    setInfo({commit}, info) {
      commit('setInfo', info);
    },
    clear({commit}) {
      commit('clear');
    }
  }
}

export default notifications;